<template>
  <div class="wrapper">
    <Datepicker
      v-model="_date"
      :language="ja"
      format="yyyy年M月d日"
      :clear-button="clearable"
      calendar-button
      calendar-button-icon="far fa-calendar"
    />
  </div>
</template>

<script>
// @see https://github.com/charliekassel/vuejs-datepicker#usage
import Datepicker from 'vuejs-datepicker';
import { ja } from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

/**
 * @return 'YYYY-MM-DD'
 */
export default {
  components: {
    Datepicker
  },
  props: {
    value: String,
    fromNow: Boolean,
    clearable: Boolean
  },
  computed: {
    _date: {
      get() {
        return this.value;
      },
      set(val) {
        if (!val) {
          this.$emit('input', null);
        } else {
          this.$emit('input', moment(val).format('YYYY-MM-DD'));
        }
      }
    }
  },
  data: () => ({
    ja: ja,
    time: null,
    disablePast: {
      to: moment(moment().format('YYYY-MM-DD')).toDate() //常に今日の日付を設定（時間以下は切り捨て）
    }
  })
};
</script>

<style lang="stylus" scoped>
.wrapper
  margin: 15px 10px
  min-width 200px

.vdp-datepicker >>> input[type=text]
  width 150px;
  padding: 7px 10px 7px 7px;
  border: 1px #a0a0a0 solid;
  border-radius: 2px;

.vdp-datepicker >>> input[type=text]:hover
  cursor: pointer;
</style>
